import {
  Info as Icon // TODO: select an icon
} from 'components/icons';

export const meta = {
  id: 'DSCrudModulesDetails',
  title: 'DSCrudModulesDetails',
  // category: 'xxx',
  allowIconOverwride: true,
  allowTitleOverwride: true,
  allowWindowOptionsOverwride: true,
  unique: false,
  icon: Icon,
  version: '1.0.0',
  description: `The CRUD module used to deal with DataStructures`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    width: 670,
    height: 510
  }
};
